var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 19,
    viewBox: "0 0 17 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.06445 18.1377C9.09212 18.1322 9.11979 18.1211 9.14746 18.1045C9.17513 18.0934 9.2028 18.0796 9.23047 18.063L15.73 14.3608C16.1174 14.1395 16.4106 13.8877 16.6099 13.6055C16.8146 13.3177 16.917 12.8722 16.917 12.269V5.80273C16.917 5.54818 16.8949 5.33789 16.8506 5.17188L9.06445 9.62109V18.1377ZM7.92725 18.1377V9.62109L0.141113 5.17188C0.0968424 5.33789 0.074707 5.54818 0.074707 5.80273V12.269C0.074707 12.8722 0.177083 13.3177 0.381836 13.6055C0.586589 13.8877 0.879883 14.1395 1.26172 14.3608L7.76953 18.063C7.7972 18.0796 7.8221 18.0934 7.84424 18.1045C7.87191 18.1211 7.89958 18.1322 7.92725 18.1377ZM8.5 8.625L12.0444 6.61621L4.18359 2.12549L1.13721 3.86035C0.949056 3.96549 0.794108 4.0734 0.672363 4.18408L8.5 8.625ZM13.1982 5.96045L16.3193 4.18408C16.1976 4.0734 16.0454 3.96549 15.8628 3.86035L10.0024 0.523438C9.48779 0.224609 8.98698 0.0751953 8.5 0.0751953C8.00749 0.0751953 7.50391 0.224609 6.98926 0.523438L5.3042 1.47803L13.1982 5.96045Z",
    fill: "#B77EFF"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBox);
export default __webpack_public_path__ + "static/media/box.cdebdcd0dcb7aacc953c9b3e885a6013.svg";
export { ForwardRef as ReactComponent };